/* eslint-disable */
import '@babel/polyfill';
import Vue from 'vue';
import './filters';
import './plugins/vuetify';
import './plugins/vueMediaQueries';
import App from './App.vue';
import store from './store/store';
import Toasted from 'vue-toasted';
import http from './http';
import instance from './plugins/myAxios';
import moment from 'moment';
require('moment/locale/pt-br');
import Vuelidate from 'vuelidate';
import panZoom from 'vue-panzoom'
import Vue2TouchEvents from 'vue2-touch-events'
import * as Sentry from "@sentry/vue";
import router from './router'
import VueAnalytics from 'vue-analytics';
import VueGtag from "vue-gtag";

Vue.use(VueGtag, {
  bootstrap: false
});

Sentry.init({
  Vue: Vue,
  dsn: "https://d387c327d2fb435198ce1912a5c5b6e3@o308444.ingest.sentry.io/5714106",
});


Vue.use(Vue2TouchEvents, {
  tapTolerance: 10,
})

Vue.use(VueAnalytics, {
  id: 'UA-2141304-1',
  ecommerce: {
    enabled: true
  },
  // router
})

Vue.use(panZoom)
Vue.use(Toasted);
Vue.use(instance);
Vue.use(Vuelidate);

Vue.config.productionTip = false;

// http (Axios customizado)
Vue.prototype.$http = http;

// Moment
Vue.prototype.$moment = moment;

Vue.mixin({
  computed: {
    isSmAndDown () {
      return this.$mq == 'mobile' || this.$mq == 'sm' || this.$mq == 'tablet'
    },
  },
  methods: {
    dateString(date, format = 'DD/MMMM/YYYY') {
      if (this.$moment(date).isValid())
        return this.$moment(date).format(format);
      return null;
    },
    timeString(date, format = 'HH[:]mm') {
      if (this.$moment(date).isValid())
        return this.$moment(date).format(format);
      return null;
    },
    clearStore() {
      let keys = ['userProps', 'signSteps', 'clientToken'];
      for (const key in keys) {
        if (this.getLS(key)) {
          window.localStorage.removeItem(key);
        }
      }
    },
    initStore() {
      let clientToken = this.getLS('clientToken');
      let expiresIn = this.getLS('expiresIn');
      if (
        clientToken &&
        expiresIn &&
        typeof this.setClientToken != 'undefined'
      ) {
        this.setClientToken({
          access_token: clientToken,
          expires_in: expiresIn,
        });
      }

      let userProps = this.getLS('userProps');
      if (userProps && typeof this.setUserProps != 'undefined') {
        this.setUserProps(userProps);
      }

      let signSteps = this.getLS('signSteps');
      if (signSteps && typeof this.setSignSteps != 'undefined') {
        this.setSignSteps(signSteps);
      }
    },
    // recover data from LocalStorage (LS)
    getLS(key) {
      let data = JSON.parse(window.localStorage.getItem(key));
      if (!!data) return data;
      return null;
    },
  },
  computed: {
    isSmAndDown () {
      return this.$mq == 'mobile' || this.$mq == 'sm' || this.$mq == 'tablet'
    },
  }
});

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app-checkout');
